"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=working-hours.dto.js.map